import { render, staticRenderFns } from "./ProofPreview.vue?vue&type=template&id=4cb3da9a&scoped=true"
import script from "./ProofPreview.vue?vue&type=script&lang=js"
export * from "./ProofPreview.vue?vue&type=script&lang=js"
import style0 from "./ProofPreview.vue?vue&type=style&index=0&id=4cb3da9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb3da9a",
  null
  
)

export default component.exports